import { Select } from "antd";
const { Option } = Select;

export default function SelectLabelAplicacion({
  label,
  onChange,
  placeholder,
  value,
  name,
  error,
}) {
  const handleChange = (val) => {
    onChange({ target: { name, value: val } });
  };

  return (
    <div>
      <div className={`inputLabel ${error && "error"} `}>{label}</div>
      <Select
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        <Option value="Manual">Manual</Option>
        <Option value="Automatica">Automatica</Option>
      </Select>
    </div>
  );
}
